import React from 'react'
import Login from './photo-organiser/login.js'
import Ajax from '../../../utils/ajax'
import Modal from '../../utils/ope-modal'
import Loader from '../../utils/ope-loader'
import Config from '../../../config'
import OpeOrderItem from '../../../objects/opeorderitem'
import UploadActions from '../../../actions/upload-actions'
import SelectorActions from '../../../actions/selector-actions'
import PhotoorganiseActions from '../../../actions/photoorganise-actions'
import ProductCalculations from '../../../utils/product-calculations'
import PhotoorganiseStore from '../../../stores/photoorganise-store'
import OpeImagePhotoorganiser from '../../../objects/opeimage/photoorganiser'
import SaveApi from '../../../utils/save-api'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import Timer from "../../../utils/timer"
import POLogo from '../../../../assets/images/vi-logo-white.jpg'
import createReactClass from 'create-react-class'
import PhotoSelector from '../photoselector'

//Login token needs to be refreshed quite often
function refreshToken(reactComponent) {
    Timer.set("OrganiseTokenRefresh", function() {
        if (sessionStorage.hasOwnProperty("photoOrganiseRefreshToken")) {

            Ajax.post({
                url: Config.PhotoOrganiseAuthApi + '/api/v1/token',
                responseType: 'JSON',
                body: 'grant_type=refresh_token&refresh_token=' + sessionStorage.getItem("photoOrganiseRefreshToken"),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (result) {
                sessionStorage.setItem("photoOrganiseLoginToken", result["access_token"]);
                sessionStorage.setItem("photoOrganiseRefreshToken", result["refresh_token"]);
                refreshToken(reactComponent);
            }).catch(function (error) {
                if (reactComponent.mounted) {
                    reactComponent.setState({isLoggedIn: false});
                    refreshToken(reactComponent);
                }
            })
        } else {
            if (reactComponent.mounted) {
                reactComponent.setState({isLoggedIn: false});
                refreshToken(reactComponent);
            }
        }

    }.bind(reactComponent), 5 * 60 * 1000);
}

function getPhotoorganiseData() {
    return PhotoorganiseStore.getData();
}

var PhotoOrganiser = createReactClass({
    mounted: false,

    getInitialState: function () {
        return {
            isLoggedIn: sessionStorage.hasOwnProperty("photoOrganiseLoginToken"),
            modalOpen: false,
            storeData: getPhotoorganiseData(),
            loadingFromPO: false
        }
    },
    componentWillMount: function () {
        PhotoorganiseStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        this.mounted = false;
        PhotoorganiseStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState({storeData: getPhotoorganiseData()});
    },
    //Load images from the basket in Photo Organiser
    _loadImagesFromPOBasket: function () {
        var self = this;
        this.setState({loadingFromPO: true});
        SaveApi.loadFromPhotoorganiser().then(function () {
            self.closeModal(true);
            self.setState({isLoggedIn: true, loadingFromPO: false});
        })['catch'](function (error) {
            if (error.error.status === 401) {
                self.logout();
            } else {
                displayError(error.message, error);
            }
        });
    },
    //Load images from temporary selection API. This is different from loading from PO Basket
    _loadImagesFromTemporarySelection: function (temporarySelectionId) {
        var self = this;
        this.setState({loadingFromPO: true});
        SaveApi.loadFromTemporarySelectionApi(temporarySelectionId).then(function () {
            self.closeModal(true);
            self.setState({isLoggedIn: true, loadingFromPO: false});
        })['catch'](function (error) {
            if (error.error.status === 401) {
                self.logout();
            } else {
                displayError(error.message, error);
            }
        });
    },
    loginSuccessCallback: function () {
        if (this.mounted) {
            this.getPOUserId();
            if (sessionStorage.getItem("loadposelection") == "true") {
                this.closeModal();
                this._loadImagesFromPOBasket();
                sessionStorage.removeItem("loadposelection");
            } else if (sessionStorage.getItem("tempSelectionId") && sessionStorage.getItem("tempSelectionId") != "undefined") {
                this.closeModal();
                this._loadImagesFromTemporarySelection(sessionStorage.getItem("tempSelectionId"));
                sessionStorage.removeItem("tempSelectionId");
            } else {
                this.closeModal(true);
                this.setState({isLoggedIn: true});
                this.openPhotoOrganiser();
            }
        }
    },
    getPOUserId: function () {
        Ajax.get({
            url: Config.PhotoOrganiseAuthApi + '/api/v1/account/userInfo',
            responseType: 'JSON',
            headers: {
                'accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("photoOrganiseLoginToken")
            }
        }).then(function (result) {
            sessionStorage.setItem("photoOrganiseUserId", result["userId"]);
        }).catch(function (error) {
            displayError(_("Unable to get Photo Organise User ID from API", {error: error}));
        })
    },
    logout: function () {
        sessionStorage.removeItem("photoOrganiseLoginToken");
        sessionStorage.removeItem("photoOrganiseRefreshToken");
        if (this.mounted) {
            this.setState({isLoggedIn: false});
        }
    },
    getPOUserName: function (accessToken) {
        return Ajax.get({
            url: Config.PhotoOrganiseAuthApi + '/api/v1/account/externalLoginUserName',
            responseType: 'JSON',
            headers: {
                'accept': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        }).then(function (result) {
            return result.suggestedUserName;            
        }).catch(function (error) {
            displayError(_("Unable to get Photo Organise User Name from API", {error: error}));
        })
    },
    registerPOUser: function (userName, accessToken) {
        return Ajax.post({
            url: Config.PhotoOrganiseAuthApi + '/api/v1/account/registerExternal',
            responseType: 'JSON',
            body: "userName=" + userName,
            headers: {
                'accept': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function () {
            return;            
        }).catch(function (error) {
            displayError(_("Unable to register Photo Organise User", {error: error}));
        })
    },
    componentDidMount: function () {
        var self = this;
        self.mounted = true;

        //When the iframe is done with login, it will post a message with the access token
        window.addEventListener("message", function (e) {

            if (typeof e.data === "object") {
                //User registered, but does not yet have an accunt in PO
                if (e.data.accessToken && !e.data.refreshToken) {
                    self.getPOUserName(e.data.accessToken).then((userName) => self.registerPOUser(userName, e.data.accessToken)).then(() => {
                        self.closeModal();
                        self.openPhotoOrganiser();
                    }).catch(function (error) {
                        displayError(_("Unable to register User", {error: error}));
                    })
                }

                //User is logged in
                if (e.data.accessToken && e.data.refreshToken) {
                    sessionStorage.setItem("photoOrganiseLoginToken", e.data.accessToken);
                    sessionStorage.setItem("photoOrganiseRefreshToken", e.data.refreshToken);
                    if (self.mounted) {
                        self.loginSuccessCallback();
                    }
                }
            }
        });

        //If the customer arrived directly from Photo Organiser with prints in their PO basket
        //we need to login to PO and fetch the images
        if (sessionStorage.getItem("loadposelection") == "true" && !this.state.isLoggedIn) {
            this.openPhotoOrganiser(); //Will only use the login, then close it and fetch images from API
        } else if (sessionStorage.getItem("loadposelection") == "true" && this.state.isLoggedIn) {
            self._loadImagesFromPOBasket();
            sessionStorage.removeItem("loadposelection");
        }

        //If the customer has made a temporary selection from XSELL or other, then load that selection of images into the editor
        if (sessionStorage.getItem("tempSelectionId") && sessionStorage.getItem("tempSelectionId") != "undefined" && !this.state.isLoggedIn) {
            this.openPhotoOrganiser(); //Will only use the login, then close it and fetch images from API
        } else if (sessionStorage.getItem("tempSelectionId") && sessionStorage.getItem("tempSelectionId") != "undefined" && this.state.isLoggedIn) {
            self._loadImagesFromTemporarySelection(sessionStorage.getItem("tempSelectionId"));
            sessionStorage.removeItem("tempSelectionId");
        }

        refreshToken(this);       

    },
    //THis is used to get a fake image height and width based on one of the thumbs
    //It gives the width and height in the same ratio but always a fixed
    //height of 2500. This is because PO Api sometimes does not give width and height
    //and the boss wants it released quickly
    getImageWidthAndHeightInAVeryHackyWay: function (imageData) {
        var thumbHeight = imageData.Thumbnails[0].Height;
        var thumbWidth = imageData.Thumbnails[0].Width;

        var ratio = thumbHeight / thumbWidth;
        return {width: Math.round(2500 / ratio), height: 2500};
    },
    addImage: function (data) {

        if (data.VisibleWidth == 0 || data.VisibleHeight == 0) {
            var size = this.getImageWidthAndHeightInAVeryHackyWay(data);
            data.VisibleHeight = size.height;
            data.VisibleWidth = size.width;
        }


        //Create image
        var image = new OpeImagePhotoorganiser(data.ImageId, data.Thumbnails, data.VisibleWidth, data.VisibleHeight);

        //Add image to ImageStore
        UploadActions.addImageToStore(image);

        //Create order item
        var orderItem = new OpeOrderItem(data.ImageId, null, {
            quantity: 1, position: {"percentageX": 0, "percentageY": 0},
            scale: 1.0, filter: false, filename: data.Name, imageFilter: {}
        });

        var selectedProduct = ProductCalculations.autoSelectProduct(image.getWidth(), image.getHeight(), sessionStorage.getItem("autoSelectProduct"), sessionStorage.getItem("autoSelectProductWidth"));

        orderItem.setProductId(selectedProduct.productId);
        orderItem.setProductWidth(selectedProduct.productWidth);
        orderItem.setProductHeight(selectedProduct.productHeight);
        orderItem.setPercentage({
            width: data.OriginalWidth,
            height: data.OriginalHeight
        });

        // Check the ratio difference of the product selected
        if (selectedProduct.matchRatioDiff > Config.ProductRatioWarning) {
            orderItem.setAutoCropWarning(true);
        }
        // Check DPI of uploaded image
        var imageProductDPI = ProductCalculations.getDPI(selectedProduct, image.getWidth(), image.getHeight());

        // @TODO the 300 value should be checked from a config file
        if (imageProductDPI < 300) {
            orderItem.setLowResWarning(true);
        }

        //Figure out if the image is portrait or landscape mode
        var fileIsPortrait = ProductCalculations.isPortrait(image.getWidth(), image.getHeight(), 0, null);

        orderItem.isPortrait = fileIsPortrait;

        //Set the date of when the image was taken (if available)
        var date = Date.parse(data.Date);
        if (date) {
            //Set the date of when the image was taken (if available)
            orderItem.setImageTakenDate(date / 1000);
        }

        //Add order item to store
        SelectorActions.addOrderItem(orderItem);

        //Mark this image as imported from photoorganiser
        PhotoorganiseActions.toggleImageImported(data.ImageId);
    },
    getSelectedCount: function () {
        var count = 0;
        for (var imageId in this.state.storeData.selection) {
            if (this.state.storeData.selection.hasOwnProperty(imageId)) {
                count++;
            }
        }
        return count;
    },

    openPhotoOrganiser: function () {
        this.setState({modalOpen: true});       
    },

    importPhotos: function () {
        var data = PhotoorganiseStore.getData();
        var importCount = 0;
        for (var imageId in data.selection) {
            if (data.selection.hasOwnProperty(imageId)) {
                importCount++;
                this.addImage(data.selection[imageId]);
            }
        }
        this.closeModal(true);
        PhotoorganiseActions.deleteSelection();
        AdobeAnalytics.photosImportedFromPhotoOrganiser(importCount);
    },
    selectTimelineView: function () {
        if (this.state.storeData.timeline && this.state.storeData.timeline.length > 0) {
            PhotoorganiseActions.setSelectedView({type: 'timeline', year: this.state.storeData.timeline[0].Year});
        } else {
            PhotoorganiseActions.setSelectedView({type: 'timeline'});
        }
    },
    selectEventsView: function () {
        if (this.state.storeData.events && this.state.storeData.events.length > 0) {
            PhotoorganiseActions.setSelectedView({type: 'events', eventId: this.state.storeData.events[0].EventId});
        } else {
            PhotoorganiseActions.setSelectedView({type: 'events'});
        }
    },
    selectCollectionsView: function () {
        if (this.state.storeData.collections && this.state.storeData.collections.length > 0) {
            PhotoorganiseActions.setSelectedView({
                type: 'collections',
                collectionId: this.state.storeData.collections[0].CollectionId
            });
        } else {
            PhotoorganiseActions.setSelectedView({type: 'collections'});
        }
    },
    closeModal: function (removeBackdrop) {
        this.setState({modalOpen: false});
        if (removeBackdrop) { //Sometimes the backdrop of the modal is not removed and we need to do it manually
            $(".reveal-modal-bg").remove();
            $("body").css("overflow", "visible");
        }
    },
    render: function () {

        var openButton = <div onClick={this.openPhotoOrganiser} className="ope-selector__photoorganise__open">
            <img src={POLogo} alt=""/>
            <span>{_("Use photos from minnebanken")}</span>
        </div>
        if (!this.state.modalOpen) {
            if (this.state.loadingFromPO) {
                return (
                    <div>
                        {openButton}
                        <Modal className="ope-arc-modal" show={true} id="photoorganiser-loding-modal"
                               closeCallback={this.closeModal}>
                            <header className="ope-section__header ope-photoorganise__header">
                                <h2>{_("Loading photos from minnebanken...")}</h2>
                            </header>
                            <div className="main">
                                <Loader/>
                            </div>
                        </Modal>
                    </div>
                );
            } else {
                return openButton;
            }

        } else {
            if (this.state.isLoggedIn) {
                return (
                    <div>
                        {openButton}
                        <Modal className="ope-arc-modal" show={this.state.modalOpen} 
                               closeCallback={this.closeModal} contentStyle={{width: "95%", height: "95%", lineHeight: "15px"}}>
                                <PhotoSelector onSelectedItems={ (items) => {
                                        AdobeAnalytics.photosImportedFromPhotoOrganiser(items.length);
                                        SaveApi.loadImageList(items.map(i => i.id));
                                        this.closeModal(true);
                                    }} />                           
                        </Modal>
                    </div>
                );
            } else {
                return (
                    <div>
                        {openButton}
                        <Modal className="ope-arc-modal" show={this.state.modalOpen} id="photoorganiser-login-modal"
                               closeCallback={this.closeModal}>
                            <Login loginSuccessCallback={this.loginSuccessCallback}/>
                        </Modal>
                    </div>
                );
            }
        }

    }
});

export default PhotoOrganiser;
